import { BaseActionObject, StateNodeConfig } from "xstate4"
import { Context, Transitions } from "../../types"
import { baseTransition } from "../transitions"
import { GetOrgClassesResponse } from "../../../../../types/gqlTypes/graphql"

export const undoDeleteTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  ...baseTransition<GetOrgClassesResponse>(
    "undeleteClass",
    "undeleteClass",
    "backToPrevious",
    {
      loadingState: "remove",
      onSuccess: (ctx, _evt) => ({
        snackbar: {
          message: `Successfully added ${ctx.snackbarMessageInfo}`,
          withUndo: false,
          error: false
        },
        lastDeletedClassRecordId: null
      }),
      onError: (ctx, _evt) => ({
        snackbar: {
          message: `An error occurred. Unable to add ${ctx.snackbarMessageInfo}`,
          withUndo: false,
          error: true
        }
      })
    }
  )
}
